// B2 Level Aggregator - Upper-Intermediate
// Tüm B2 ünite içeriklerini birleştirir

import { B2_UNIT_1 } from './kariyerContentsB2Unit1';
import { B2_UNIT_2 } from './kariyerContentsB2Unit2';
import { B2_UNIT_3 } from './kariyerContentsB2Unit3';
import { B2_UNIT_4 } from './kariyerContentsB2Unit4';
import { B2_UNIT_5 } from './kariyerContentsB2Unit5';
import { B2_FINAL } from './kariyerContentsB2Final';

export const B2_LEVEL = {
  ...B2_UNIT_1,  // Present Perfect
  ...B2_UNIT_2,  // Past Continuous
  ...B2_UNIT_3,  // Second Conditional
  ...B2_UNIT_4,  // Passive Voice
  ...B2_UNIT_5,  // Reported Speech
  ...B2_FINAL,   // Final Sınavı
};

export default B2_LEVEL;
